import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";

export const MastersShow: React.FC<IResourceComponentsProps> = () => {
    return <AntdInferencer />;
};
